import { publishError } from './PublishStore';

export const updatePublishError = (value) => publishError.update((oldValue) => value);
